<div mat-flat-button class="formclose" align="right"
	(click)="closeAnalyticsForm()">
	<img src="assets/img/icons/forma-11.png">
</div>
<div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
	<div class="loginbox">
		<div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
			<form [formGroup]="analytics" class="example-form">
				<div class="fheader">Add Analytics</div>
				<div class="flabel">Name</div>
				<mat-form-field appearance="outline" class="example-full-width"
					style="width:100%"> <mat-label>Enter
				Name</mat-label> <input matInput formControlName="name" value=""> </mat-form-field>
				<mat-error *ngIf="validator.UniqueAnalytics">{{validator.errorMessage}}</mat-error>


				<div class="flabel">Power BI URL</div>
				<mat-form-field appearance="outline" class="example-full-width"
					style="width:100%"> <mat-label>Enter
				power BI URL</mat-label> <input matInput formControlName="powerBIURL" value="">
				</mat-form-field>

				<div class="flabel">
					Logo <input type="file" style="display: none"
						(change)="onfileselected($event)" #fileInput> <span
						class="Rounded-Rectangle-1" mat-button (click)="fileInput.click()"><img
						src="assets/img/icons/UploadBlue.png"></span>
					<!-- <button mat-button (click)="onUpload()">Upload File</button> -->

					<img *ngIf="logoPreview" style="height: 30px; width: 30px"
						src="data:image/png;base64,{{logoPreview}}" />

				</div>

				<div class="flabel">Type</div>
				<mat-radio-group formControlName="type"
					(change)="getSelectedType($event)"> <mat-radio-button
					class="example-radio-button" *ngFor="let type of types"
					[value]="type">{{type}}</mat-radio-button> </mat-radio-group>

				<div class="flabel">Entity</div>
				<mat-form-field appearance="outline" style="width:48%">
				<mat-label>Input Entities</mat-label> <mat-select multiple
					disableRipple (selectionChange)="Entitychange($event.value)"
					formControlName="entities"> <mat-option
					*ngFor="let entity of entity" [value]="entity.name">
				{{entity.name}} </mat-option> </mat-select> </mat-form-field>

				<mat-form-field *ngIf="!isGeneralType" appearance="outline"
					style="width:48%;padding-left:10px"> <mat-label>Required
				Parameter</mat-label> <mat-select multiple disableRipple
					formControlName="Attributes"> <mat-option
					*ngFor="let requiredAttribute of requiredAttribute"
					[value]="requiredAttribute.name">
				{{requiredAttribute.name}} </mat-option> </mat-select> </mat-form-field>

				<button mat-flat-button style="width: 100%"
					[disabled]="!analytics.valid" mat-flat-button class="formbutton"
					(click)="createAnalytics()">Add</button>
			</form>
		</div>
	</div>

</div>
